import { oneLine } from 'common-tags';
import { ErrorMessage, Field } from 'formik';

import type { FieldProps } from 'formik';
import type { FunctionComponent } from 'react';
import type { TypeTextInputProps } from './types';

export const TextInput: FunctionComponent<TypeTextInputProps> = ({
  className = '',
  name,
  label,
  disabled = false,
  placeholder = '',
  type = 'text',
  Icon,
  onClick,
  value,
  readOnly = false,
}: TypeTextInputProps) => (
  <Field name={name} value={value}>
    {({ field, meta: { error, touched } }: FieldProps) => (
      <div
        className={`flex flex-col aria-disabled:opacity-40 ${className}`}
        aria-disabled={disabled}
      >
        <div className="flex flex-col gap-2">
          {label && (
            <label
              htmlFor={name}
              className={oneLine`text-body text-body-s ${error && touched ? 'text-status-error' : ''} `}
            >
              {label}
            </label>
          )}
          <div className="relative flex">
            <input
              id={name}
              type={type}
              placeholder={placeholder}
              disabled={disabled}
              onClick={onClick}
              readOnly={readOnly}
              className={oneLine`text-body text-body-m placeholder:text-placeholder w-full rounded-input py-3 ${Icon && 'pr-10'} ${
                error && touched
                  ? 'color-status-error border-status-error ring-status-error placeholder:text-status-error focus:border-status-error focus:ring-status-error active:border-status-error active:ring-status-error'
                  : 'border-neutrals-500 placeholder:text-text-neutrals-500 focus:border-neutrals-900 focus:ring-neutrals-900 active:border-neutrals-500 active:ring-neutrals-900'
              } ${className} `}
              {...field}
            />
            {Icon && (
              <Icon
                width={24}
                className={oneLine`pointer-events-none absolute top-1/2 right-2.5 shrink-0 -translate-y-1/2 ${error && touched ? 'text-status-error' : 'text-neutrals-500'} `}
              />
            )}
          </div>
        </div>

        <ErrorMessage name={name}>
          {(msg) => (
            <div className="text-body text-body-s text-status-error">{msg}</div>
          )}
        </ErrorMessage>
      </div>
    )}
  </Field>
);

TextInput.displayName = 'TextInput';
